import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#44403c",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.4",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "M10.833 5.833 7.25 2.25a2.01 2.01 0 0 0-2.833 0L2.25 4.417a2.01 2.01 0 0 0 0 2.833l3.583 3.583M6.667 5l1.666-1.667M15 13.333l1.667-1.666M14.167 9.167l3.583 3.583c.783.783.783 2.05 0 2.833l-2.167 2.167a2 2 0 0 1-2.833 0l-3.583-3.583M17.645 5.677a2.349 2.349 0 1 0-3.322-3.323L3.202 13.478c-.194.193-.337.43-.417.692l-1.1 3.627a.417.417 0 0 0 .518.518l3.628-1.1c.26-.08.498-.222.691-.414zM12.5 4.167 15.833 7.5" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }